<template>
  <div class="text-center">
    <h2>Signing you in...</h2>
    <Loading/>
    <p v-if="slow">
      This is taking longer than usual. <a class="link" @click="goBack">Go back</a>
    </p>
  </div>
</template>

<script>
  /* eslint-env browser */
  import Loading from '../components/helpers/Loading';
  import { handleCallback, returnToClub } from '../lib/sso';

  const SLOW_AFTER_MS = 15000;

  // The Cognito Hosted UI sends the browser here after Google / Apple sign-in.
  // We finish the sign-in and go back to the brewery page it started from.
  export default {
    name: 'OAuthCallback',
    components: { Loading },
    data() {
      return { slow: false };
    },
    created() {
      this.timer = setTimeout(() => { this.slow = true; }, SLOW_AFTER_MS);
      handleCallback(this.$route.query, (returnPath) => {
        this.$router.replace(returnPath);
      });
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    methods: {
      goBack() {
        returnToClub();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// OAuthCallback.vue?4b8650bd